export const DISABLE_STORE_CHANGE_DIALOG = false;
